<template>
  <div class="layout-list">
    <div class="table-wrapper table-scrollbar">
      <table class="table table-hover table-sm table">
        <thead>
          <tr>
            <th scope="col">User</th>
            <th scope="col">Project</th>
            <th scope="col">Date</th>
            <th scope="col">Time</th>
            <th scope="col">Details</th>
          </tr>
        </thead>
        <tbody>
          <tr
            @click="selectLog(log)"
            v-for="log in logs.slice().reverse()"
            :class="selectedLog && selectedLog.id === log.id ? 'table-active' : ''"
          >
            <td>
              <img :src="log.user.iconUrl" />
              {{log.user.fullname}}
            </td>
            <td>
              <div class="box" :style="boxStyle(log)"></div>
              {{log.project.title}}
            </td>
            <td>{{log.dateSummary}}</td>
            <td>{{log.hours}} {{log.hours === 1 ? 'hour' : 'hours'}}</td>
            <td>{{log.details.length > 50 ? log.details.substring(0, 50)+"..." : log.details}}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  props: ["logs", "selected-log"],
  methods: {
    selectLog(log) {
      this.$emit("select-log", {
        selectedLog: log
      });
    },
  },
   computed: {
    formatDate() {
      return (log) => {
        return log.date;
      }
    },
    boxStyle() {
      return (log) => {
        return {
          backgroundColor: log.project.color
        };
      }
    }
   }
};
</script>



// WEBPACK FOOTER //
// assets/js/components/work-logs/List.vue